module.exports = __webpack_public_path__ + "img/pc_nav_bg.b2fc2fe.webp";